import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/x-admin/about-us";

const updateAbout = async (data) => {
  return await axios.post(API_ENDPOINT, data, {
    withCredentials: true,
    headers: { ...authHeader(), Accept: "application/json" },
  });
};
const getAbout = async () => {
  const response = await axios.get(API_ENDPOINT, {
    withCredentials: true,
    headers: { ...authHeader(), Accept: "application/json" },
  });
  return response;
};

const aboutServices = {
  getAbout,
  updateAbout,
};
export default aboutServices;
